import { useQuery } from "@tanstack/react-query";
import { SCHOOL_INSTALLMENTS_INVOICE_PAYMENT } from "../../../apiRoutes";
import axiosAuth from "../../../../axiosAuth";

export interface PaymetData {
  _id: string;
  paymetId: string;
  installmentId: string;
  paymetNumber: string;
  paymetAmount: number;
  paymetDate: string;
  paymetStatus: string;
  paymetAmountReceived: number;
  paymetClearedDate?: string;
  paymetRemarks: string;
  paymetYear: string;
  createdAt: string;
  updatedAt: string;
  paymetCreatedByData:any;
  paymentRemarksHistory: any[];
}

export interface PaymetResponse {
  data: PaymetData[];
  message: string;
  success: boolean;
}

export const useGetPaymetByInstallmentIdQuery = (
  installmentId: string,
  options?: { enabled?: boolean }
) => {
  return useQuery({
    queryKey: ["payment", installmentId],
    queryFn: async (): Promise<PaymetResponse> => {
      const response = await axiosAuth.get(`${SCHOOL_INSTALLMENTS_INVOICE_PAYMENT}${installmentId}/`);
      return response.data;
    },
    enabled: !!installmentId && (options?.enabled ?? true),
  });
};
